<template>
    <transition name="base-modal">
        <div v-if="baseModalShouldMountedRoot" class="base-modal">
            <div
                class="base-modal__backdrop"
                :class="{ 'base-modal--destroying': !baseModalOpen, ...customBackdropClass }"></div>

            <div
                class="base-modal__main w-11/12 sm:w-full"
                :class="{ 'base-modal--destroying': !baseModalOpen, ...customContentClass}">
                <slot></slot>

                <feather-icon
                    v-if="closeable"
                    @click="onClose"
                    class="base-modal__main--close"
                    icon="XIcon" />
            </div>
        </div>
    </transition>
</template>

<script>
import FeatherIcon from "../Icons/FeatherIcon.vue";

export default {
    name: "base-modal",

    components: {
        FeatherIcon,
    },

    props: {
        open: {
            type: Boolean,
            default: false,
        },

        // milliseconds to unmount root modal core
        unmountAfterMs: {
            type: Number,
            default: 400,
        },

        // It's mean we cannot control this modal. Permission control by base-modal handle
        uncontrolled: {
            type: Boolean,
            default: false,
        },

        // It's mean we can control this modal
        controlled: {
            type: Boolean,
            default: false,
        },

        closeable: {
            type: Boolean,
            default: true,
        },

        customContentClass: {
            type: Object, 
            default: () => ({})
        },
        customBackdropClass: {
            type: Object, 
            default: () => ({})
        },

        // @emit
        // this.$emit("close", boolean)
        // this.$emit("destroyed", boolean)
    },

    data() {
        return {
            baseModalOpen: this.open || false,
            baseModalShouldMountedRoot: false,

            timerOut: null,
        };
    },

    watch: {
        /**
         * Listen change "open" props
         */
        open() {
            if (this.controlled && !this.uncontrolled) {
                if(!this.open) {
                    setTimeout(() => {
                        this.$data.baseModalOpen = false;
                        this.onShouldMountModal();
                    }, this.unmountAfterMs - 300);
                }
                else {
                    this.$data.baseModalOpen = true;
                    this.onShouldMountModal();
                }
            } else if (this.controlled && this.uncontrolled) {
                throw new Error(
                    "ModalCoreComponent: Just only 'controlled' or 'uncontrolled' is true "
                );
            } else if (!this.controlled && !this.uncontrolled) {
                throw new Error(
                    "ModalCoreComponent: Should assign data type boolean for 'controlled' or 'uncontrolled' props"
                );
            }
        },
        /**
         * Listen change "baseModalOpen" props
         */
        baseModalOpen() {
            if (this.uncontrolled && !this.controlled) {
                this.onShouldMountModal();
            } else if (this.controlled && this.uncontrolled) {
                throw new Error(
                    "ModalCoreComponent: Just only 'controlled' or 'uncontrolled' is true "
                );
            } else if (!this.controlled && !this.uncontrolled) {
                throw new Error(
                    "ModalCoreComponent: Should assign data type boolean for 'controlled' or 'uncontrolled' props"
                );
            }
        },
    },

    methods: {
        onShouldMountModal(cb = () => {}) {
            if (this.baseModalOpen) {
                this.$data.baseModalShouldMountedRoot = true;
            } else {
                if (this.timerOut) clearTimeout(this.timerOut);

                this.timerOut = setTimeout(() => {
                    this.$data.baseModalShouldMountedRoot = false;
                }, this.unmountAfterMs || 400);
            }

            cb && cb();
        },

        onClose() {
            if(this.uncontrolled && !this.controlled) {
                this.baseModalOpen = false;
            }
            
            this.$emit("close", this.baseModalOpen);
        },
    },

    mounted() {
        this.onShouldMountModal();
    },

    beforeDestroy() {
        this.$emit("destroyed");
    }
};
</script>

<style lang="scss">
$backdropZIndex: 100000;

.base-modal {
    &__backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba($color: #000000, $alpha: 0.3);
        z-index: $backdropZIndex;

        transition: all 300ms ease;
    }

    &__main {
        width: 100%;
        max-width: 377px;
        min-height: 220px;
        border-radius: 6px;
        background-color: var(--vs-hex-white);

        padding: 20px;

        position: fixed;
        top: 50%;
        left: 50%;
        box-shadow: 0 1px 14px rgba($color: #000000, $alpha: 0.1);

        transform: translate(-50%, -50%);

        z-index: $backdropZIndex + 1;
        transition: all 300ms ease;

        &--close {
            position: absolute !important;
            top: 10px;
            right: 10px;
            cursor: pointer;
        }
    }

    &--destroying {
        opacity: 0;
    }
}

@media screen and (max-width: calc(var(--vs-breakpoint-sm) - 1px)) {
    .base-modal {
        &__main {
            width: calc(100% - 30px);
        }
    }
}

.base-modal {
    &-enter,
    &-leave-to {
        .base-modal__backdrop {
            visibility: hidden;
            opacity: 0;
        }

        .base-modal__main {
            transform: translate(-50%, -50%) scale(0.8);
        }
    }

    &-enter-to,
    &-leave {
        .base-modal__backdrop {
            visibility: visible;
            opacity: 1;
        }

        .base-modal__main {
            transform: translate(-50%, -50%) scale(1);
        }
    }

    &-enter-active,
    &-leave-to-active {
        transition: all 300ms ease;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/BaseModal.vue